import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const PrivateRoute = ({ element, allow, deny }) => {
    const authToken = localStorage.getItem('token');

    // Determine if the user is authenticated and the token is valid
    const isAuthenticated = !!authToken;
    let isExpired = false;
    let userRole = null;

    if (isAuthenticated) {
        try {
            const decoded = jwtDecode(authToken);
            isExpired = decoded.exp * 1000 < Date.now(); // Check if the token is expired
            userRole = decoded.role;
        } catch (error) {
            console.error('Token decoding failed:', error);
            isExpired = true; // If decoding fails, consider the token expired
        }
    }

    // Redirect to login if not authenticated or if the token is expired
    if (!isAuthenticated || isExpired) {
        console.log('Token is invalid or expired, navigating to login.');
        localStorage.removeItem('token'); // Clean up expired or invalid token
        return <Navigate to="/login" replace />;
    }

    // Role-based access control
    if (allow && !allow.includes(userRole)) {
        console.warn(`Access denied: role '${userRole}' is not allowed`);
        return <Navigate to={`/${jwtDecode(authToken).userId}`} replace />;
    }

    if (deny && deny.includes(userRole)) {
        console.warn(`Access denied: role '${userRole}' is explicitly denied`);
        return <Navigate to={`/${jwtDecode(authToken).userId}`} replace />;
    }

    // If authenticated and token is valid, render the requested element
    return element;
};

export default PrivateRoute;
